import React, { useState, useRef, useEffect, ReactNode } from 'react'
import styled, { keyframes } from 'styled-components'
import listenForOutsideClicks from '../../listenForOutsideClicks'
import { LiveBlueIcon } from '../actions/edit'
// import { fadeIn } from 'react-animations'

interface Props {
    icon?: string
    hideInsideIcon?: boolean
    closeOnClick?: boolean
    title?: string
    label?: string
    useBorder?: boolean
    children: ReactNode[]
}

export default function DropDownIcon({
    title,
    label,
    icon = 'fas fa-ellipsis-v',
    hideInsideIcon = false,
    useBorder = false,
    closeOnClick = false,
    children = []
}: Props): JSX.Element {
    const wrapperRef = useRef(null)
    const [dropDown, setDropDown] = useState(false)

    useEffect(
        listenForOutsideClicks(dropDown, wrapperRef, () => setDropDown(false)),
        [dropDown]
    )

    return (
        <div ref={wrapperRef}>
            <Container useBorder={useBorder} label={label} onClick={() => setDropDown(!dropDown)}>
                <Icon className={`${icon} outside`} data-cy="dropDownIconClose" />
                {label ? <span className="dropdown-icon-label">{label}</span> : null}
                <DropDownContainer className={!dropDown ? 'hidden' : ''}>
                    {!hideInsideIcon ? (
                        <Icon
                            className={`${icon} intside`}
                            onClick={() => setDropDown(false)}
                            style={{
                                position: 'absolute',
                                right: 4,
                                top: 18
                            }}
                        />
                    ) : null}
                    {title ? <label>{title}</label> : null}
                    <ul>
                        {children
                            .filter(component => !!component)
                            .map(component => {
                                return (
                                    <li
                                        key={Number(title)}
                                        onClick={ev => {
                                            //need more tests to see if it not broke anything
                                            // ev.stopPropagation()
                                            if (closeOnClick) setDropDown(false)
                                        }}
                                    >
                                        {React.cloneElement(component, { setDropDown })}
                                    </li>
                                )
                            })}
                    </ul>
                </DropDownContainer>
            </Container>
        </div>
    )
}

// const animation = keyframes`${fadeIn}`
// const animation = keyframes`${fadeOutLeft}`
const animation2 = keyframes`
  from {
    height: 0px;
    /* width: 0px; */
  }
  to {
    height: 263px;
    /* width: 250px; */
  }
`
const Container = styled.div<{ useBorder; label }>`
    font-family: Source Sans Pro;
    height: 100%;
    position: relative;

    cursor: pointer;
    ${({ theme, label, useBorder }) => {
        return label
            ? `
            display: flex;
            gap: 5px;
            width: 100px;
            height: 25px;
            border: ${useBorder ? '1px solid ' + theme['blue-500'] : ''};

            .dropdown-icon-label {
                font-size: 14px;
                font-family: Source Sans Pro;
                font-weight: 600;
                line-height: 16px;
                color: ${theme['blue-500']};
            }
        
            :hover {
                >i {
                    color: ${theme['blue-700']}
                }
                border: ${useBorder ? '1px solid ' + theme['blue-700'] : ''};
                .dropdown-icon-label {
                    color: ${theme['blue-700']}
                }
            }
        `
            : ''
    }}
`
const Icon = styled(LiveBlueIcon)`
    /* font-family: Font Awesome 5 Pro; */
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    /* line-height: 40px; */
    color: #37a3ef;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    &.outside {
        padding-top: 2px;
    }

    &.inside {
        line-height: 16px;
    }
    cursor: pointer;
`

const DropDownContainer = styled.div`
    .hiden {
        display: none;
    }
    font-family: Source Sans Pro;
    position: absolute;
    top: -2px;
    left: -225px;
    width: 250px;
    z-index: 99;
    padding: 1.5rem 1rem;
    border: 1px solid rgba(0, 0, 0, 0.04);
    box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.14);
    background-color: white;
    border: 1px solid #c8ccd4;

    label {
        font-style: normal;
        font-size: 12px;
        line-height: 16px;
        padding: 8px 12px;
        text-transform: uppercase;
        color: ${({ theme }) => theme['gray-600']};
    }

    ul {
        font-family: SourceSansPro, Arial, Helvetica Neue, Helvetica, sans-serif;
        list-style: none;
        padding: 0;
        margin: 0;
    }

    li {
        padding: 0px 7px;
        min-height: 32px;
        &:hover {
            background-color: ${({ theme }) => theme['blue-200']};
            font-weight: 600;

            cursor: pointer;
        }
    }
`
